import React, { useState } from 'react';
import { Form, Select, Space } from 'antd';
import styleText from '../../../../../shared/components/rbh-text/styles';
import { RBHBox, RBHButton, RBHSelect, RBHImage } from '../../../../../shared/components';
import styleButton from '../../../../../shared/components/rbh-button/styles';
import styles, { martCategoryLayout, buttonLayout } from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { httpCreators } from '@ppvrbh/merchant-frontend-core';
import { MartCategoryService } from '../../redux/martCategory-service';
import { FormattedMessage } from 'react-intl';
import { martCategorySagas } from '../../redux/martCategory-saga';
import { MART_CATEGORY_REQUEST_ID_LIST, MART_CATEGORY_GROUPING_ID } from '../../redux/martCategory-constant';
import { martCategoryStateSelector, MART_CATEGORY_STATE_KEY } from '../../redux/martCategory-reducer';
import { Images } from '../../../../../shared/theme';

export const FormTransfer: React.FC<Props> = (p) => {

  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const productCategoryList = useSelector(martCategoryStateSelector(MART_CATEGORY_STATE_KEY.MASTER_DATA)) as [];
  const [selectedCategory, setSelectCategory] = useState(null);
  const [promotionCategory, setPromotionCategory] = useState(false);

  const isPromotionCategory = (productCategoryGroupingId: number) => {
    return productCategoryGroupingId === MART_CATEGORY_GROUPING_ID.PROMOTION;
  };

  const onFinish = (value: any) => {
    dispatch(httpCreators.request({
      id: MART_CATEGORY_REQUEST_ID_LIST.POST_TRANSFER_MART_CATEGORY,
      sagaHandler: martCategorySagas.postTransferMartCategoryHanlder as any,
      callbackParams: p.onSuccessCallback,
      service: MartCategoryService.postTransferMartCategory,
      serviceParams: {
        currentProductCategoryId: p.data.productCategoryId,
        newProductCategoryId: value.newProductCategory
      }
    }));
  };

  const getCurrentProductCategory = () => {
    const { Option } = Select;
    return (
      <Option
        key={p.data.productCategoryId}
        id={'currentProductCategory'}
        data-testid={'currentProductCategory'}
        value={p.data.productCategoryId}
      >
        {isPromotionCategory(p.data.productCategoryGroupingId) && (
          <RBHImage style={styles.iconPromotion} src={Images.promotion}
            id={'currentProductCategoryPromotionIcon'} data-testid={'currentProductCategoryPromotionIcon'} />
        )}
        {p.data.productCategoryNameTH}
      </Option>
    );
  };

  const getMasterProductCategory = () => {
    const { Option } = Select;
    const productCategory = productCategoryList && productCategoryList.map((value: any, index) => {
      return (
        <Option
          style={isPromotionCategory(value.productCategoryGroupingId) ? styles.textPromotion : styleText.formText}
          key={index}
          id={`productCategoryOption-${index}`}
          data-testid={`productCategoryOption-${index}`}
          value={value.productCategoryId}
        >
          {isPromotionCategory(value.productCategoryGroupingId) && (
            <RBHImage style={styles.iconPromotion} src={Images.promotion}
              id={'newProductCategoryPromotionIcon'} data-testid={'newProductCategoryPromotionIcon'} />
          )}
          {value.productCategoryNameTH}
        </Option>
      );
    });
    return productCategory;
  };

  const handleOnChange = (value: any) => {
    const productCategory: any = productCategoryList.find((item: any) => item.productCategoryId === value);
    setPromotionCategory(isPromotionCategory(productCategory?.productCategoryGroupingId));
    setSelectCategory(value);
  };

  return (
    <RBHBox style={styles.defaultContent}>
      <Form size={'large'} form={form} style={styleText.formText} {...martCategoryLayout} onFinish={onFinish}>
        <Form.Item colon={false} name={'currentProductCategory'}
          label={<FormattedMessage id={'main.mart.category.transfer.field.category.current.label'} />}
        >
          <RBHSelect disabled data-testid={'currentProductCategory'}
            id={'currentProductCategory'}
            defaultValue={p.data.productCategoryId}
            suffixIcon={''}
          >
            {getCurrentProductCategory()}
          </RBHSelect>
        </Form.Item>
        <Form.Item colon={false} name={'newProductCategory'} required={true}
          label={<FormattedMessage id={'main.mart.category.transfer.field.category.new.label'} />}
        >
          <RBHSelect onChange={handleOnChange} data-testid={'newProductCategoryDropdown'}
            id={'newProductCategoryDropdown'} placeholder={'main.mart.category.transfer.field.category.new.placeholder'}
            style={promotionCategory && styles.textPromotion}
          >
            {getMasterProductCategory()}
          </RBHSelect>
        </Form.Item>
        <Form.Item {...buttonLayout} style={styles.buttonContainer} >
          <Space size={'middle'}>
            <RBHButton id={'cancelButton'} data-testid={'cancelButton'} style={styleButton.buttonFromCancelGradient}
              type={'primary'} htmlType={'button'}
              onClick={p.onCancel} text={'main.mart.category.transfer.btn.cancel'} />
            <RBHButton disabled={!selectedCategory} id={'transferButton'} data-testid={'transferButton'}
              style={styleButton.buttonFromConfirmGradient}
              type={'primary'}
              htmlType={'submit'} text={'main.mart.category.transfer.btn.confirm'} />
          </Space>
        </Form.Item>
      </Form>
    </RBHBox>
  );
};
type Props = {
  onCancel?: any;
  onSuccessCallback?: any;
  data: any;
};

